import { Badge, Spinner, UncontrolledTooltip } from "reactstrap";
import { ArrowUpCircle } from "react-feather";
import { useCallback } from "react";

import { dateFormatInvoice, formatCnpj } from "utils";
import Avatar from "@components/avatar";
import { handleConfirmAlertHtml } from "components/Structure/ConfirmAlert";
import { useIgnoreProduct } from "useCases";

const UnignoreProduct = ({ row, revalidate }) => {
  const { onUnignoreProduct, isLoading } = useIgnoreProduct();

  const handleUnignore = useCallback(async () => {
    await onUnignoreProduct(row.id).then(() => revalidate());
  }, [row.id, onUnignoreProduct, revalidate]);

  const handleClick = () => {
    if (isLoading) return;
    
    return handleConfirmAlertHtml(
      {
        title: "Remover produto ignorado",
        html: "Ao remover esse produto ele será re-adicionado na listagem de produtos e será contabilizado na análise fiscal.",
        icon: "info",
        textBtn: "Sim, continuar!",
      },
      handleUnignore,
    );
  };

  return (
    <>
      <div id={`btn-restore-${row.id}`}>
        <Avatar
          icon={isLoading ? <Spinner size="sm" /> : <ArrowUpCircle size={18} />}
          color="light-secondary"
          onClick={handleClick}
        />
      </div>
      <UncontrolledTooltip placement="top" target={`btn-restore-${row.id}`}>
        Remover
      </UncontrolledTooltip>
    </>
  );
};

export const columns = revalidate => [
  {
    name: "",
    selector: row => <UnignoreProduct row={row} revalidate={revalidate} />,
    width: "70px",
  },
  {
    name: "CNPJ",
    selector: row => (
      <Badge color="primary">{formatCnpj(row.cnpj_empresa) || "---"}</Badge>
    ),
    width: "160px",
  },
  {
    name: "Produto",
    cell: row => (
      <div className="d-flex flex-column">
        <span className="fw-bolder">{row.xprod}</span>
        <small className="text-muted">Cód: {row.cprod}</small>
      </div>
    ),
    width: "550px",
  },
  {
    name: "EAN",
    selector: row => row.ean,
    minWidth: "150px",
  },
  {
    name: "Movimento",
    selector: row => (
      <Badge
        color={
          row?.tipo_movimento === "ENTRADA" ? "light-warning" : "light-info"
        }
      >
        {row.tipo_movimento}
      </Badge>
    ),
    minWidth: "150px",
  },
  {
    name: "Data",
    selector: row => dateFormatInvoice(row.dt_insert) || "---",
    minWidth: "180px",
  },
];
